var gallery = {
	selectors: {
		filterNavItems: '.gallery-filter button',
        galleryFilterMixitup: '.gallery-filter-mixitup'
	},
	init: function () {
		var self = this;

		jQuery( '.only-first-row__button .button' ).on( 'click', function( event ){
			event.preventDefault();
			jQuery( this ).closest( 'section' ).addClass( 'view-all' );
		});

		if( jQuery( self.selectors.filterNavItems ).length ) {
            jQuery( self.selectors.filterNavItems ).on( 'click', function( event ) {
                event.preventDefault();
                console.log("aaa")

                var filterItems = jQuery( this ).parent().parent().find( '.gallery__item' );
                var sectionType = jQuery( this ).attr( 'data-items' );

                if( ! jQuery( this ).hasClass( 'active' ) ) {
                    jQuery( this ).parent().find( '.active' ).removeClass( 'active' );
                    jQuery( this ).addClass( 'active' );

                    var theClass = 'gallery__item--' + sectionType;

                    if( sectionType == 'all' ) {
                        filterItems.removeClass( 'invisible' );
                    } else {

                        jQuery.each( filterItems, function() {
                            if( ! jQuery( this ).hasClass( theClass ) ) {
                                jQuery( this ).addClass( 'invisible' );
                            } else {
                                jQuery( this ).removeClass( 'invisible' );
                            }
                        });
                    }
                }
            });
        }

        if( jQuery( self.selectors.galleryFilterMixitup ).length ) {
            jQuery('.masonry-grid').mixItUp({
                selectors: {
                    target: '.gallery__item',
                    filter: '.gallery-filter-mixitup__link',
                },

                animation: {
                    animateResizeContainer: false,
                    effects: 'fade scale'
                }
        });
        }
	},
};

export { gallery };
